// extracted by mini-css-extract-plugin
export default {"rosterHeader":"Header_rosterHeader__cv3A7","topLabel":"Header_topLabel__N-dnH","bottomLabel":"Header_bottomLabel__aMFdB"};